<template>
  <div class="card card-info" id="divEdit">
    <div class="card-header with-border">
      <h3 class="card-title">Fee Deposit</h3>
    </div>
    <!-- /.card-header -->
    <!-- form start -->
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          Challan No
          <div class="input-group input-group-sm" style="width: 300px">
            <input type="text" class="form-control" placeholder="Enter Challan No" v-model="challanNo">
            <span class="input-group-append">
              <button class="btn btn-info btn-flat" type="button" v-on:click="searchChallan()">Search</button>
            </span>
          </div>
        </div>
      </div>

      <div v-if="show === 'show'" style="margin-top: 5px">
        <div class="row">
          <div class="col-md-12">
            <h5 style="font-weight: bold">Student Detail</h5>
            <hr style="margin-top: -5px;" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-10 col-sm-12 col-xs-12">
            <div class="row" style="margin-top: 0px;">
               
              <div class="col-md-6">
                <label>Department</label>
                <input class="form-control" maxlength="35" v-model="st.DepartmentName" disabled="disabled" />
              </div> 
              <div class="col-md-6">
                <label class="">Program</label>
                <input class="form-control" maxlength="35" v-model="st.ProgramName" disabled="disabled" />
              </div>
            </div>
            <div class="row" style="margin-top: 6px;"> 
              <div class="col-md-6">
                <label>Student Name</label>
                <input class="form-control" maxlength="35" v-model="st.Name" disabled="disabled" />
              </div>
              <div class="col-md-6">
                <label>Roll No./ Form No.</label>
                <input class="form-control" maxlength="35" v-model="st.FormNo" disabled="disabled" />
              </div>
            </div>
             
          </div>

          <div style="text-align: right;" class="col-md-1 col-sm-3 col-xs-3 thumbnail">
            <img v-bind:src="st.Image" alt="img" width="100px" />
          </div>
        </div>

        <div class="row" style="margin-top: 5px;">
          <div class="col-md-12">
            <h5 style="font-weight: bold">Challan Details</h5>
            <hr style="margin-top: -5px;" />
          </div>
        </div>

        <div class="row" style="padding-right: 2%">
           
          <div class="col-md-3">
            <label>Challan No.</label>
            <input class="form-control" v-model="st.ChallanNo" disabled="disabled" />
          </div> 
          <div class="col-md-3">
            <label>Gen. Date</label>
            <input class="form-control" v-model="st.Date" disabled="disabled" />
          </div> 
          <div class="col-md-3">
            <label>Due Date</label>
            <input class="form-control" v-model="st.DueDate" disabled="disabled" />
          </div>
        </div>
         
        <div class="row" style="margin-top: 5px;">
          <div class="col-md-12">
            <h5 style="font-weight: bold">Payment Details</h5>
            <hr style="margin-top: -5px;" />
          </div>
        </div>
        <div class="row" style="padding-right: 2%; margin-top: 6px;"> 
          <div class="col-md-3">
            <label>Payment Type</label>
            <select class="form-control" v-model="st.PaymentType">
              <option value="" selected="selected" disabled="disabled">--Select Type--</option> 
              <option value="Bank">Bank</option>
            </select>
          </div> 
          <div class="col-md-3" v-if="st.PaymentType == 'Bank'">
            <label>Bank Name</label>
            <input class="form-control" v-model="st.BankName" />
          </div> 
          <div class="col-md-3" v-if="st.PaymentType == 'Bank'">
            <label>Bank Branch</label>
            <input class="form-control" v-model="st.BranchName" />
          </div> 
          <div class="col-md-3">
            <label>Receipt #</label>
            <input class="form-control" v-model="st.SlipNo" />
          </div> 
          <div class="col-md-3">
            <label>Date</label>
            <input type="date" class="form-control" v-model="st.DepositDate" />
          </div>
        </div>

        <div class="row" style="margin-top: 7px">
          <div class="col-md-12">
            <table class=" table table-bordered table-sm" width="100%">
              <thead class="bg-info">
                <tr>
                  <th width="2%">Sr.No.</th>
                  <th width="80%">Fee Head</th>
                  <th width="18%">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, ind) in feeheads">
                  <td>{{ind+1}}</td>
                  <td>{{item.FeeHeadName}}</td>
                  <td align="right">{{item.Total.toLocaleString()}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!--<div class="row" style="padding-right: 2%; text-align: right; margin-top: 6px;">
          <div class="col-md-12">
            <label>Amount to be Paid: <span id="lblTotalAmount">{{st.}}</span></label>
          </div>
          <div class="col-md-12">
            <label>Total Amount Paid: <span id="lblTotalPayment">0</span></label>
          </div>
          <div class="col-md-12">
            <label>Bal Amount Paid: <span id="lblTotalPayment">0</span></label>
          </div>
        </div>-->
      </div>
    </div>
    <!--Button -->


    <div class="card-footer" style="text-align:right" >
      <a type="button" class="btn btn-primary float-left" href="../fee/FeeDepositRecord">Back To List</a>
      <button class="btn btn-success" Width="120px" v-on:click="save()" v-if="show === 'show'">Save</button>
      <button class="btn btn-danger" Width="120px" v-on:click="cancel()" v-if="show === 'show'">Cancel</button>
    </div>
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        show: 'hide',
        challanNo: '',
        st: {
          StudentID: 0,
          Name: '',
          Image: '',
          Department: '',
          DepartmentID: '',
          Program: '',
          ProgramID: '',
          Session: '',
          SessionID: '',
          RollNo: '',
          ChallanNo: '',
          Date: '',
          DueDate: '',
          PaymentType: 'Bank',
          BranchName: '',
          BankName: '',
          Receipt: '',
          DepositDate: '',
          Amount: '',
          Total: '',
          Balance: '',
        },
        feeheads: [],
      }
    },
    created: function () {
    },
    updated: function () {
    },
    methods: {
      searchChallan() {
        startReq();
        var vm = this;
        axios.post('/api/FeeApi/SearchChallan?challanNo=' + vm.challanNo)
          .then(function (response) {
            endReq();
            if (response.data.status) { 
              vm.show = 'show',
                vm.st = response.data.data;
              vm.feeheads = response.data.gfChild;
            }
            else {
              toastr.error(response.data.msg, "Error!")
            }
          })
      },

      save() {
        if (this.st.PaymentType == "") {
          toastr.error("Please Select Payment Types");
          return;
        }
        if (this.st.PaymentType == "Bank" && this.st.BankName == '') {
          toastr.error("Please Enter Bank Name");
          return;
        }
        if (this.st.PaymentType == "Bank" && this.st.BranchName == '') {
          toastr.error("Please Enter Branch Name");
          return;
        }
        if (this.st.DepositDate == "") {
          toastr.error("Please Enter date");
          return;
        }
        else {
          startReq();
          var vm = this;
          axios.post('/api/FeeApi/SaveDeposit', {
            obj: vm.st,
            child: vm.feeheads,
          })
            .then(function (res) {
              endReq();
              if (res.data.status) {
                toastr.success("Deposited Successfully");
                window.open("../Fee/FeeDepositPrint", "_blank");
                setTimeout(window.location.reload(), 2000);
              }
              else {
                toastr.error(res.data.msg);
              }
            })
        }
      },

      cancel() {
        window.location.reload();
      }
    }
  })
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/fee/feedeposit.vue